import i18n from 'modules/core/lib/i18n'

import { Description, Title } from './elements'

export const GrowthPlans = () => {
  return (
    <>
      <Title>
        {i18n.t('app_store_v2.apps.growth_plans_custom_table.description_view.title_1')}
      </Title>
      <Description>
        {i18n.t('app_store_v2.apps.growth_plans_custom_table.description_view.description_1')}
      </Description>
      <Title>
        {i18n.t('app_store_v2.apps.growth_plans_custom_table.description_view.title_2')}
      </Title>
      <Description>
        {i18n.t('app_store_v2.apps.growth_plans_custom_table.description_view.description_2')}
      </Description>
      <Title>
        {i18n.t('app_store_v2.apps.growth_plans_custom_table.description_view.title_3')}
      </Title>
      <Description>
        {i18n.t('app_store_v2.apps.growth_plans_custom_table.description_view.description_3')}
      </Description>
    </>
  )
}
